import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { BehaviorSubject } from 'rxjs';

import { AppFeatureMetrics } from '../../models';
import { SNACKBAR_CONSTANTS } from '../../shared/constants';
import { AppsDataService } from '../data-services';
import { FeatureUsageLogicServiceModel } from './models';

@Injectable({
    providedIn: 'root',
})

export class FeatureUsageLogicService {
    private _isLoading = new BehaviorSubject<boolean>(false);
    private _isLoaded = new BehaviorSubject<boolean>(false);

    isLoading$ = this._isLoading.asObservable();
    isLoaded$ = this._isLoaded.asObservable();

    model: FeatureUsageLogicServiceModel = new FeatureUsageLogicServiceModel();

    constructor(
        private _appsDataService: AppsDataService,
        private _snackBar: MatSnackBar
    ) { }

    clearModel(): void {
        this.model = new FeatureUsageLogicServiceModel();
        this._isLoading.next(false);
        this._isLoaded.next(false);
    }

    getAppFeatureMetrics(): void {
        if (this._isLoading.value || this._isLoaded.value) {
            return;
        }
        this._isLoading.next(true);
        this._appsDataService.getAppFeatureMetrics().subscribe({
            next: (appFeatureMetrics: AppFeatureMetrics[]) => {
                this.model.appFeatureMetrics = appFeatureMetrics.sort((a, b) => a.appName.localeCompare(b.appName));
                this._isLoading.next(false);
                this._isLoaded.next(true);
            },
            error: () => {
                this._snackBar.open(
                    SNACKBAR_CONSTANTS.ITEM_ACTION_ERROR('feature usage data', 'loading'),
                    SNACKBAR_CONSTANTS.CLOSE,
                    { duration: 5000 }
                );
                this._isLoading.next(false);
                this._isLoaded.next(false);
            }
        });
    }
}
